import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faArrowLeft,
    faArrowRight,
    faArrowsMaximize,
    faBan,
    faBars,
    faBellExclamation,
    faBolt,
    faBookOpenLines,
    faBuildingCircleArrowRight,
    faBuildings,
    faBusinessTime,
    faCalendar,
    faCalendarCheck,
    faCalendarClock,
    faCalendarExclamation,
    faCalendarPen,
    faCalendarPlus,
    faCamera,
    faCameraRetro,
    faCameraRotate,
    faCarpool,
    faCars,
    faCarBurst,
    faCarSide,
    faCarWrench,
    faChartMixed,
    faCheck,
    faCheckDouble,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsUp,
    faChevronUp,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleXmark,
    faClipboardListCheck,
    faClockRotateLeft,
    faCloudPlus,
    faCommentCaptions,
    faCommentCheck,
    faCommentPlus,
    faCopy,
    faDownload,
    faEnvelope,
    faEnvelopeCircleCheck,
    faEnvelopeDot,
    faEnvelopesBulk,
    faEuroSign,
    faEye,
    faEyeSlash,
    faFaceTongueMoney,
    faFile,
    faFileArrowDown,
    faFileArrowUp,
    faFileCode,
    faFileInvoiceDollar,
    faFileMagnifyingGlass,
    faFlagPennant,
    faFloppyDisk,
    faFolder,
    faFolderArrowDown,
    faFolderArrowUp,
    faFolderTree,
    faHandshake,
    faHeadSide,
    faHeadSideGear,
    faHouseBuilding,
    faIdCard,
    faImage,
    faImageCirclePlus,
    faImageSlash,
    faInboxes,
    faIndustryWindows,
    faInputText,
    faKey,
    faLightbulbMessage,
    faLink,
    faListCheck,
    faListTree,
    faMagnifyingGlass,
    faMagnifyingGlassArrowsRotate,
    faMagnifyingGlassMinus,
    faMailbox,
    faMailboxFlagUp,
    faMapLocationDot,
    faMemo,
    faMessageCaptions,
    faMessagesQuestion,
    faMobileArrowDown,
    faMoneyBillTrendUp,
    faMoneyCheckDollar,
    faMoonStars,
    faObjectsColumn,
    faPaperclip,
    faPaperPlaneTop,
    faPen,
    faPeopleGroup,
    faPeopleLine,
    faPeopleRoof,
    faPersonCircleCheck,
    faPersonCircleXmark,
    faPersonWalkingArrowLoopLeft,
    faPersonWalkingArrowRight,
    faPlus,
    faQuestion,
    faRectangleList,
    faRectangleXmark,
    faReplyClock,
    faRightFromBracket,
    faRotate,
    faScreenUsers,
    faShareNodes,
    faSliders,
    faSparkles,
    faStop,
    faSquareList,
    faSunBright,
    faSwap,
    faThumbsDown,
    faTire,
    faTrashCan,
    faTrashCheck,
    faTriangleExclamation,
    faUser,
    faUserClock,
    faUserHatTieMagnifyingGlass,
    faUsersMedical,
    faUsersRays,
    faWandSparkles,
    faWarehouse,
    faWrench,
    faXmark,
} from '@fortawesome/pro-duotone-svg-icons';

export const OKAPI_APP_ICON_DEFINITIONS: IconDefinition[] = [
    faUser,
    faPlus,
    faCameraRetro,
    faImageCirclePlus,
    faIndustryWindows,
    faEnvelopesBulk,
    faArrowLeft,
    faArrowRight,
    faAngleLeft,
    faAngleRight,
    faChevronsUp,
    faPersonCircleXmark,
    faCommentCheck,
    faCameraRotate,
    faBolt,
    faPaperclip,
    faWandSparkles,
    faChartMixed,
    faCarWrench,
    faMagnifyingGlassMinus,
    faFileArrowUp,
    faMagnifyingGlass,
    faMessagesQuestion,
    faQuestion,
    faRightFromBracket,
    faCalendarClock,
    faCalendar,
    faRectangleXmark,
    faCarBurst,
    faCarpool,
    faCars,
    faMoonStars,
    faSunBright,
    faBars,
    faFile,
    faFolder,
    faFolderArrowDown,
    faFolderArrowUp,
    faMessageCaptions,
    faMobileArrowDown,
    faEye,
    faEyeSlash,
    faClipboardListCheck,
    faCloudPlus,
    faXmark,
    faBuildingCircleArrowRight,
    faIdCard,
    faReplyClock,
    faSquareList,
    faEuroSign,
    faFileCode,
    faTrashCan,
    faCarSide,
    faPeopleLine,
    faCheck,
    faCheckDouble,
    faDownload,
    faBuildings,
    faListTree,
    faPen,
    faLightbulbMessage,
    faHeadSideGear,
    faCircleExclamation,
    faFileInvoiceDollar,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faRectangleList,
    faFlagPennant,
    faBookOpenLines,
    faMoneyCheckDollar,
    faUsersRays,
    faUsersMedical,
    faScreenUsers,
    faPeopleGroup,
    faCircleXmark,
    faWarehouse,
    faHouseBuilding,
    faFaceTongueMoney,
    faPersonCircleCheck,
    faImage,
    faImageSlash,
    faMailboxFlagUp,
    faCircleInfo,
    faMailbox,
    faMemo,
    faKey,
    faObjectsColumn,
    faLink,
    faInboxes,
    faInputText,
    faSparkles,
    faStop,
    faEnvelope,
    faPeopleRoof,
    faEnvelopeDot,
    faCalendarCheck,
    faMoneyBillTrendUp,
    faShareNodes,
    faUserClock,
    faHeadSide,
    faCamera,
    faMapLocationDot,
    faMagnifyingGlass,
    faFileMagnifyingGlass,
    faMagnifyingGlassArrowsRotate,
    faBellExclamation,
    faClockRotateLeft,
    faListCheck,
    faCalendarExclamation,
    faFloppyDisk,
    faFolderTree,
    faPaperPlaneTop,
    faSwap,
    faRotate,
    faCalendarPlus,
    faThumbsDown,
    faUserHatTieMagnifyingGlass,
    faTire,
    faSliders,
    faTriangleExclamation,
    faHandshake,
    faCalendarPen,
    faBusinessTime,
    faArrowsMaximize,
    faPersonWalkingArrowRight,
    faPersonWalkingArrowLoopLeft,
    faCommentCaptions,
    faCommentPlus,
    faEnvelopeCircleCheck,
    faFileArrowDown,
    faBan,
    faCircleCheck,
    faWrench,
    faTrashCheck,
    faCopy,
    faAngleUp,
    faAngleDown,
];
